import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "../../../styles/Form.css";
import { MODE } from "../../../constants/SiteConstants";

const Customform = ({
  fields = [],
  onSubmit,
  mode,
  initialData = {},
  handleImageChange,
  imagePreview, // Expecting single image preview from props
}) => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (mode === MODE.UPDATE) {
      setFormData(initialData);
    }
  }, [initialData, mode]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      handleImageChange(e); // Call parent function to handle image upload
      // Automatically set the formData image if needed for upload
      setFormData((prevData) => ({
        ...prevData,
        image: file,
      }));
    }
  };

  const validateForm = () => {
    const formErrors = {};
    fields.forEach((field) => {
      const value = formData[field.name];
      if (field.required && !value) {
        formErrors[field.name] = `${field.label} is required`;
      }
    });
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      onSubmit(formData);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {fields.map((field) => (
        <div className="mb-4" key={field.name}>
          <label
            htmlFor={field.name}
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            {field.label}
          </label>
          {field.type === "file" ? (
            <>
              <input
                type="file"
                name={field.name}
                accept="image/*"
                onChange={handleFileChange}
                className="mt-2 border rounded-md w-full"
              />
              {imagePreview && (
                <div className="mt-2">
                  <img
                    src={imagePreview}
                    alt="preview"
                    style={{ width: "100px", height: "100px", objectFit: "cover" }}
                    className="rounded-md"
                  />
                </div>
              )}
            </>
          ) : field.type === "rich-text" ? (
            <ReactQuill
              value={formData[field.name] || ""}
              onChange={(value) => handleChange({ target: { name: field.name, value } })}
              placeholder={field.placeholder}
              className="mt-2"
            />
          ) : (
            <input
              type={field.type}
              name={field.name}
              value={formData[field.name] || ""}
              onChange={handleChange}
              placeholder={field.placeholder}
              className="mt-2 border rounded-md px-3 py-2 w-full"
            />
          )}
          {errors[field.name] && (
            <div className="mt-1 text-red-600">{errors[field.name]}</div>
          )}
        </div>
      ))}
      <button
        type="submit"
        className="mt-4 w-full rounded-lg bg-[#1C2434] text-white py-3 hover:bg-[#1C2434]"
      >
        Submit
      </button>
    </form>
  );
};

export default Customform;
